export var ROUTE_NAME;
(function (ROUTE_NAME) {
    ROUTE_NAME["MANAGEMENT"] = "management";
    ROUTE_NAME["DEPOSIT"] = "deposit";
    ROUTE_NAME["WITHDRAW"] = "withdraw";
    ROUTE_NAME["HOME"] = "home";
    ROUTE_NAME["INFO"] = "info";
    ROUTE_NAME["NFT"] = "nft";
})(ROUTE_NAME || (ROUTE_NAME = {}));
